export default {
    path: 'mix_withdraw',
    component: () => import(/* webpackChunkName: "withdraw-list" */ '@/pages/mix/WithdrawList'),
    meta: {title:'发放列表',cate:'查询中心'}
}